<template>
  <div :class="['notification_item', { 'unread-notification': !notification.read_at }]">
    <div class="notification_item--icon">
      <icon-default :icon="icon" size="is-small"></icon-default>
    </div>

    <div class="notification_item--main">
      <component v-bind:is="notificationComponent" :notification="notification"></component>
    </div>

    <div class="notification_item--meta">
      <p class="is-size-8 mb-25">{{ datetime }}</p>
      <button-link @click="deleteNotification">Delete</button-link>
    </div>
  </div>
</template>

<script>
import dates from "../../../services/dates";
import AllRecordTaskCompletedNotification from "../notifications/AllRecordTaskCompletedNotification";
import AssignedToAppointmentNotification from "../notifications/AssignedToAppointmentNotification";
import AssignedToRecordNotification from "../notifications/AssignedToRecordNotification";
import CallFailedToDialForwarderNotification from "../notifications/CallFailedToDialForwarderNotification";
import EmailRepliedToNotification from "../notifications/EmailRepliedToNotification";
import FollowUpStepWarningNotification from "../notifications/FollowUpStepWarningNotification";
import InboundFollowUpNotification from "../notifications/InboundFollowUpNotification";
import MentionNotification from "../notifications/MentionNotification";
import NewCallNotification from "../notifications/NewCallNotification";
import NewEmailNotification from "../notifications/NewEmailNotification";
import NewTextNotification from "../notifications/NewTextNotification";
import OutboundWebhookErrorNotification from "../notifications/OutboundWebhookErrorNotification";
import RecordDueAtReminderNotification from "../notifications/RecordDueAtReminderNotification";
import RecordDueNotification from "../notifications/RecordDueNotification";
import RecordEnteringStatusNotification from "../notifications/RecordEnteringStatusNotification";
import RecordExitingStatusNotification from "../notifications/RecordExitingStatusNotification";
import RecordInStatusXTimeReminderNotification from "../notifications/RecordInStatusXTimeReminderNotification";
import RecordNewNotification from "../notifications/RecordNewNotification";
import RecordXTimeBeforeDueAtReminderNotification
  from "../notifications/RecordXTimeBeforeDueAtReminderNotification";
import TaskAssignedNotification from "../notifications/TaskAssignedNotification";
import TaskAssignedDueNotification from "../notifications/TaskAssignedDueNotification";
import TestUserNotificationPhoneNumberNotification from "../notifications/TestUserNotificationPhoneNumberNotification";
import WebhookFailedNotification from "../notifications/WebhookFailedNotification";
import {ENUMS} from "../../../services/enums";
import api from "../../../api";

export default {
  name: 'NotificationItem',
  components: {
    AllRecordTaskCompletedNotification,
    AssignedToAppointmentNotification,
    AssignedToRecordNotification,
    CallFailedToDialForwarderNotification,
    EmailRepliedToNotification,
    FollowUpStepWarningNotification,
    InboundFollowUpNotification,
    MentionNotification,
    NewCallNotification,
    NewEmailNotification,
    NewTextNotification,
    OutboundWebhookErrorNotification,
    RecordDueAtReminderNotification,
    RecordDueNotification,
    RecordEnteringStatusNotification,
    RecordExitingStatusNotification,
    RecordInStatusXTimeReminderNotification,
    RecordNewNotification,
    RecordXTimeBeforeDueAtReminderNotification,
    TaskAssignedNotification,
    TaskAssignedDueNotification,
    TestUserNotificationPhoneNumberNotification,
    WebhookFailedNotification,
  },
  props: {
    notification: Object
  },
  computed: {
    notificationComponent() {
      // NOTE: This removes the `App\\Notifications\\` from beginning of type, so it's just the class name
      // The component name must equal the class name of the backend notifications found in app/Notifications
      return this.notification.type.substring(18, this.notification.type.length)
    },
    icon() {
      const category = this.notification.category
      const enums = ENUMS.NotificationCategoryEnum

      if(category === enums.Mentions.value) return 'mention'
      if(category === enums.Tasks.value) return 'task'
      if(category === enums.Appointments.value) return 'appointment'
      if(category === enums.Leads.value) return 'lead'
      if(category === enums.Comms.value) return 'call'
      if(category === enums.Profile.value) return 'settings'
      if(category === enums.Errors.value) return 'warning'
      return 'notifications'
    },
    datetime() {
      return dates.formatAsDateTime(this.notification.created_at);
    },
  },
  methods: {
    deleteNotification() {
      api.notifications.delete(this.notification.id).then(() => {
        this.$emit('deleted')
        this.$buefy.toast.open({
          message: "Notification has been deleted",
          type: 'is-success'
        });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.notification_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 6px;
  padding: 2px 6px;
  border-left: 3px solid $grey-50;

  &--icon {
    color: $text-light;
  }

  &--main {
    flex-grow: 1;
    margin: 0 8px;
  }

  &--meta {
    flex-shrink: 0;
    flex-basis: 120px;
  }

  &.unread-notification {
    border-left: 3px solid $primary;
  }
}
</style>
